/*
* Chew Valley Trees Javascript
*
*/
// Vendors

// Modules
import MainNav from './components/main-nav';
import ProductGallery from './components/product-gallery';
import ProductPriceMultiplier from './components/product-price-multiplier';
import ProductTypeTabs from './components/product-type-tabs';
import ProductInfoTabs from './components/product-info-tabs';
import ForceUppercaseInput from './components/force-uppercase-input';
import SiteHelp from './components/site-help';

// Check if JS is on in browser, if so remove the `no-js` class from body
document.body.classList.remove('no-js');

// Create global instance of product price multiplier so that we can access methods from Sprig includes
window.productPriceMultiplier = new ProductPriceMultiplier();

// Create global instance of uppercase input so that we can access methods from Sprig includes
window.forceUppercaseInput = new ForceUppercaseInput();

document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.remove('preload');

  // Init Product Price Multiplier via the init function
  window.productPriceMultiplier.init();
  window.forceUppercaseInput.init();

  // Initialize Modules
  new MainNav();
  new ProductGallery();
  new ProductTypeTabs();
  new ProductInfoTabs();
  new SiteHelp();

}, false);